import { Reveal } from "@/lib/motion";
import { MovementRule } from "@/components/site/Decorations";

const PAINS = [
  "Scattered tools that don't talk to each other",
  "Manual admin eating into billable time",
  "Unclear offers and inconsistent communication",
  "Customer information stuck in inboxes and notebooks",
  "AI experiments that never make it into the workflow",
  "No single source of truth for how the business runs",
];

export default function ModernProblem() {
  return (
    <section
      data-testid="modern-problem-section"
      className="relative bg-bg-ink text-bg-base py-24 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 paper-grain opacity-[0.18] mix-blend-screen pointer-events-none" />
      {/* Decorative top rule */}
      <MovementRule className="absolute top-10 right-6 md:right-10 w-32 md:w-40 h-4 text-bg-base/60" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <Reveal>
          <div className="overline text-bg-base">The modern business challenge</div>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-7xl leading-[0.98] tracking-tight max-w-5xl text-bg-base">
            Most businesses aren't behind on technology.
            <em className="font-light text-bg-base/95"> They're stuck between eras.</em>
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-1 max-w-5xl">
          {PAINS.map((p, i) => (
            <Reveal key={p} delay={i}>
              <div className="flex items-start gap-4 py-4 md:py-5 border-b border-white/25">
                <span className="overline text-brand-red mt-1.5 font-semibold">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-base md:text-lg leading-snug text-bg-base">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={3}>
          <p className="mt-14 md:mt-16 max-w-3xl text-bg-base/90 text-base md:text-lg leading-relaxed">
            ETradingGroup helps you move out of the in-between — into clearer
            structure, smarter workflows, better communication, and practical
            AI-supported systems.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
